import { EditorContent } from '@tiptap/react'
import styled, { css } from 'styled-components'

const variableStyle = css`
    .react-renderer.node-variable {
        /* vertical-align: middle; */
        margin: 0 4px;
    }
`

export const RichTextContentCss = css`
    caret-color: #000;
    color: var(--color-black);
    font-size: 16px;
    line-height: 1.5;
    word-break: break-word;

    .ProseMirror {
        // 清除默认的层叠属性，会影响到文本渐变属性
        position: unset;
        white-space: pre-wrap;
        hyphens: auto;
        [contenteditable='false'] {
            white-space: unset;
        }

        h1,
        h2,
        h3,
        h4,
        h5 {
            margin: 16px 0 8px !important;
        }

        h1 {
            font-size: 28px;
            line-height: 1.35;
        }
        h2 {
            font-size: 22px;
            line-height: 1.45;
        }
        h3 {
            font-size: 18px;
            line-height: 1.55;
        }

        /* https://github.com/ueberdosis/tiptap/issues/412#issuecomment-1500873959 */
        p:empty {
            height: 1lh;
        }

        p.editor-placeholder:first-child::before {
            color: var(--color-gray-300);
            content: attr(data-placeholder);
            float: left;
            height: 0;
            pointer-events: none;
        }

        & > *:not(:last-child) {
            margin-bottom: 4px;
        }

        img {
            width: 100%;
            height: 100%;
            max-width: 100%;
            vertical-align: middle;
            /* &.ProseMirror-selectednode {
                outline: 2px solid var(--color-main);
                outline-offset: -2px;
            } */
        }

        ul,
        ol {
            padding: 0 8px;
            margin: 0.2em 0 0.2em 0.6em;
            li {
                margin: 3px 0;
            }
            &[data-type='taskList'] li {
                align-items: unset !important;
            }
        }

        ul[data-type='taskList'] {
            list-style: none;
            padding: 0;
            margin-left: 0;

            li {
                display: flex;
                align-items: center;

                > label {
                    flex: 0 0 auto;
                    margin-right: 0.5rem;
                    user-select: none;
                }

                > div {
                    flex: 1 1 auto;
                }
            }

            input[type='checkbox'] {
                cursor: pointer;
            }
        }

        table.rich-text-table {
            width: 100%;
            margin: 8px 0;
            border-collapse: collapse;
            table-layout: auto;
            border: 1px solid var(--color-gray-200, rgba(13, 13, 13, 0.12));
            background: var(--color-white, #fff);
        }

        table.rich-text-table th,
        table.rich-text-table td {
            position: relative;
            min-width: 80px;
            padding: 8px 12px;
            vertical-align: top;
            border: 1px solid var(--color-gray-200, rgba(13, 13, 13, 0.12));
            white-space: pre-wrap;
            word-break: break-word;
            overflow-wrap: anywhere;
        }

        table.rich-text-table td.selectedCell,
        table.rich-text-table th.selectedCell,
        table.rich-text-table .selectedCell {
            background: rgba(37, 99, 235, 0.025);
        }

        table.rich-text-table td.selectedCell::selection,
        table.rich-text-table th.selectedCell::selection,
        table.rich-text-table td.selectedCell *::selection,
        table.rich-text-table th.selectedCell *::selection,
        table.rich-text-table .selectedCell::selection,
        table.rich-text-table .selectedCell *::selection {
            background: transparent;
        }

        table.rich-text-table th {
            background: var(--color-gray-50, rgba(13, 13, 13, 0.04));
            font-weight: 600;
        }

        .tableWrapper {
            overflow-x: auto;
            position: relative;
            margin: 8px 0;
        }

        .tableWrapper .column-resize-handle {
            position: absolute;
            top: 0;
            right: -2px;
            bottom: 0;
            width: 4px;
            background: var(--color-theme-6);
            pointer-events: auto;
        }

        &.resize-cursor {
            cursor: col-resize;
        }

        table.rich-text-table p {
            margin: 0;
        }

        blockquote {
            padding-left: 8px;
            border-left: 2px solid rgba(13, 13, 13, 0.1);
        }

        hr {
            border: none;
            border-top: 2px solid rgba(13, 13, 13, 0.1);
            margin: 1rem 0;
        }

        a {
            color: var(--color-main);
            text-decoration: underline;
        }

        code {
            caret-color: #fff;
        }
    }
`

export const Content = styled(EditorContent).withConfig<{ isEditable?: boolean; minHeight?: number | string }>({
    shouldForwardProp: p => p !== 'isEditable'
})`
    ${RichTextContentCss};

    display: flex;
    flex-direction: column;

    .ProseMirror {
        flex: 1;
        min-height: ${({ minHeight }) => (typeof minHeight === 'number' ? `${minHeight}px` : minHeight)};
        ${p => p.isEditable && variableStyle}
    }
`

export const Container = styled.div`
    display: flex;
    flex-direction: column;
`
